/**
 * Postes proposés à l'inscription, repris de la maquette.
 *
 * La liste est une AIDE À LA SAISIE, pas une contrainte : le serveur accepte n'importe
 * quel intitulé (champ libre plafonné à 120 caractères), et « Autre » ouvre une saisie
 * libre. Un menu fermé ferait mentir la moitié des inscrits sur leur fonction, ce qui
 * rendrait la donnée inexploitable pour le suivi commercial — sa seule raison d'être.
 *
 * Les intitulés sont donnés dans les deux genres, comme sur la maquette : c'est la
 * première question posée à un nouveau client, autant qu'il s'y reconnaisse.
 */
export const JOB_TITLES = [
  'Président / Présidente',
  'Directeur général / Directrice générale',
  'Gérant / Gérante',
  'Fondateur / Fondatrice',
  'Directeur / Directrice marketing',
  'Responsable marketing',
  'Directeur / Directrice communication',
  'Responsable communication',
  'Chef de projet',
  'Community manager',
  'Social media manager',
  'Responsable digital',
  'Directeur artistique / Directrice artistique',
  'Responsable achats',
  'Assistant / Assistante de direction',
] as const;

/** Valeur qui déclenche la saisie libre. */
export const OTHER_JOB_TITLE = 'Autre';

/**
 * Indicatifs téléphoniques proposés.
 *
 * Limités aux pays francophones desservis : un menu de 200 indicatifs se parcourt plus
 * lentement qu'il ne se tape, et l'utilisateur peut de toute façon coller un numéro
 * international complet dans le champ.
 */
export const DIAL_CODES = [
  { code: '+33', label: 'France (+33)' },
  { code: '+32', label: 'Belgique (+32)' },
  { code: '+41', label: 'Suisse (+41)' },
  { code: '+352', label: 'Luxembourg (+352)' },
  { code: '+377', label: 'Monaco (+377)' },
  { code: '+1', label: 'Canada (+1)' },
] as const;

/**
 * Pays proposés. Les codes sont des ISO 3166-1 alpha-2, ce qu'attend l'API.
 */
export const COUNTRIES = [
  { code: 'FR', label: 'France' },
  { code: 'BE', label: 'Belgique' },
  { code: 'CH', label: 'Suisse' },
  { code: 'LU', label: 'Luxembourg' },
  { code: 'MC', label: 'Monaco' },
  { code: 'CA', label: 'Canada' },
  { code: 'ES', label: 'Espagne' },
  { code: 'IT', label: 'Italie' },
  { code: 'DE', label: 'Allemagne' },
  { code: 'PT', label: 'Portugal' },
  { code: 'GB', label: 'Royaume-Uni' },
] as const;

/**
 * Sépare un numéro stocké (« +33 04 22 11 22 11 », tel que composé à l'inscription) en
 * indicatif et numéro, pour réafficher le formulaire dans le même état qu'à la saisie.
 * Un numéro sans indicatif connu est rendu entier, sous l'indicatif par défaut.
 */
export function splitPhoneNumber(phoneNumber: string | null | undefined): {
  dialCode: string;
  number: string;
} {
  const value = (phoneNumber ?? '').trim();

  // Du plus long au plus court : « +352 » ne doit pas être lu comme « +3 » suivi de « 52 ».
  const known = [...DIAL_CODES]
    .sort((a, b) => b.code.length - a.code.length)
    .find((dialCode) => value === dialCode.code || value.startsWith(`${dialCode.code} `));

  return known === undefined
    ? { dialCode: DIAL_CODES[0].code, number: value }
    : { dialCode: known.code, number: value.slice(known.code.length).trim() };
}
